import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Box } from '@mui/material'
import {
  AccountTree,
  GridView,
  ViewStream,
  SpaceDashboard,
  ChecklistRtl,
  SupervisorAccount,
  Settings,
  Insights,
  Quiz,
  EmergencyShare,
  ToggleOn,
  Category,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Schema,
  Description,
} from '@mui/icons-material'
import { Link, useLocation, useParams } from 'react-router-dom'
import { BigLogo, HamburgerIcon } from '../../../../assets/images'
import Header from '../../Header'
import { PermittedRoutes, getLocalStorage, getPermissions, homeScreenRedirection, naiFlowAuthTab, setLocalStorage } from '../../../../utils/helper'
import { useSidebar } from '../../../../context/SidebarContext'
import { useProjectPermission } from '../../../../context/ProjectContext'
import SmartLogo from '../../SmartLogo'

type Props = {
  breadcrumbData?: any
  children: any
  page?: string
  parentPage?: string
  disableBreadcrumbLinks?: boolean
  clickableBreadcrumbIndices?: number[]
}

const DashboardLayout = (props: Props) => {
  const { breadcrumbData, children, page, parentPage, disableBreadcrumbLinks = false, clickableBreadcrumbIndices } = props
  const wrapperRef = useRef<HTMLDivElement>(null)
  const { pathname } = useLocation()
  const params = useParams()
  const { name, id } = params
  const { projectPermission, setProjectPermission } = useProjectPermission()
  const isSmallScreen = useMemo(() => window.innerWidth < 640, [])
  const [isSidebarOpen, setIsSidebarOpen] = useState(getLocalStorage('sidebar') === 'false' || isSmallScreen ? false : true)
  const [hoveredRoute, setHoveredRoute] = useState('')
  const { expandedMenus, setExpandedMenus } = useSidebar()
  const selectedRoute = `/${pathname?.split('/')[1]}`

  // useEffect(() => {
  //   if (!projectPermission && name && id && pathname?.includes(`/project-management/${name}`)) {
  //     trackPromise(
  //       api
  //         .getProjectPermissionsByProjectID(id)
  //         .then((response: any) => {
  //           if (isSuccess(response)) {
  //             setProjectPermission(response?.data?.data)
  //           }
  //         })
  //         .catch((error: any) => {
  //           showError(error)
  //         }),
  //     )
  //   }
  // }, [projectPermission])

  const toggleSidebar = () => {
    setLocalStorage('sidebar', !isSidebarOpen)
    setIsSidebarOpen(!isSidebarOpen)
  }

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event?.target as any
      if (target?.id !== 'hamburger-img' && target?.id !== 'hamburger' && wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        // setLocalStorage('sidebar', false)
        setIsSidebarOpen(false)
      }
    }

    if (isSmallScreen) {
      document.addEventListener('click', handleOutsideClick)
    }

    return () => {
      if (isSmallScreen) {
        document.removeEventListener('click', handleOutsideClick)
      }
    }
  }, [isSmallScreen])

  return (
    <div className="flex-1 h-[100vh] min-w-0">
      <div className="flex max-w-screen">
        <button id="hamburger" onClick={toggleSidebar} className="z-5 md:hidden flex items-center border-b-2 border-gray-300">
          <img id="hamburger-img" className="w-6 h-6 ml-1 md:ml-3" src={HamburgerIcon} alt="hamburger" />
        </button>
        <Header
          page={page}
          parentPage={parentPage}
          breadcrumbData={breadcrumbData}
          disableBreadcrumbLinks={disableBreadcrumbLinks}
          clickableBreadcrumbIndices={clickableBreadcrumbIndices}
        />
      </div>
      <div className={`overflow-y-auto h-[calc(100vh-64px)]  ${isSmallScreen && isSidebarOpen ? 'hidden' : ''}`}>{children}</div>
    </div>
  )
}

export default DashboardLayout
